/**
 * Generate a UUID v4 string.
 * Falls back to a custom implementation if crypto.randomUUID is not available (e.g. non-secure contexts).
 */
export const generateUUID = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    // Fallback for non-secure contexts - use timestamp and bitwise logic instead of Math.random
    let d = Date.now();
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;
    
    // Simple custom seed
    let seed = d + d2;
    
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = 0;
        
        if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
            const randomArray = new Uint8Array(1);
            crypto.getRandomValues(randomArray);
            r = randomArray[0] % 16;
        } else {
            // LCG Pseudo-random fallback without using Math.random
            seed = (seed * 9301 + 49297) % 233280;
            const pseudoRandom = seed / 233280;
            r = Math.floor(pseudoRandom * 16);
            
            if(d > 0){
                r = Math.trunc((d + r)%16);
                d = Math.floor(d/16);
            } else {
                r = Math.trunc((d2 + r)%16);
                d2 = Math.floor(d2/16);
            }
        }
        
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
